import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  InMemoryScrollingFeature,
  InMemoryScrollingOptions,
  provideRouter,
  withInMemoryScrolling,
} from '@angular/router';

import { MatIconModule } from '@angular/material/icon';

import { APP_ROUTES } from '../core/routing/app.routing';
import { CookiebotConfig } from './cookiebot.config';
import { ngxCookiebotProvider } from '@halloverden/ngx-cookiebot';
import { OAuthStorage, provideOAuthClient } from 'angular-oauth2-oidc';
import { provideNgxMask } from 'ngx-mask';

import { loaderInterceptorFn } from '@interceptors/loader-interceptor.service';
import { IconService } from '@services/icon-service/icon-service.service';

// We need a factory, since localStorage is not available during AOT build time.
export function storageFactory(): OAuthStorage {
  return localStorage;
}

const scrollConfig: InMemoryScrollingOptions = {
  scrollPositionRestoration: 'top',
  anchorScrolling: 'enabled',
};

const inMemoryScrollingFeature: InMemoryScrollingFeature = withInMemoryScrolling(scrollConfig);

export function initIcons(iconService: IconService) {
  return () => iconService.registerIcons();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(APP_ROUTES, inMemoryScrollingFeature),
    provideOAuthClient(),
    /**
     * Use it to can OAuth to store tokens in local storage
     * Remove it if you want to store OAuth tokens in session storage
     */
    { provide: OAuthStorage, useFactory: storageFactory },
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    provideNgxMask(),
    ngxCookiebotProvider(CookiebotConfig),
    provideHttpClient(withInterceptors([loaderInterceptorFn])),

    /**
     * For svg icons
     */
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(MatIconModule),
    provideAppInitializer(() => {
      const iconService = inject(IconService);
      iconService.registerIcons();
    }),
  ],
};
